namespace TabAurous.OMS {
    export interface BrandMasterRow {
        BrandId?: number;
        AttributeTypeId?: number;
        BrandCode?: string;
        BrandName?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace BrandMasterRow {
        export const idProperty = 'BrandId';
        export const nameProperty = 'BrandCode';
        export const localTextPrefix = 'OMS.BrandMaster';
        export const lookupKey = 'OMS.BrandMaster';

        export function getLookup(): Q.Lookup<BrandMasterRow> {
            return Q.getLookup<BrandMasterRow>('OMS.BrandMaster');
        }
        export const deletePermission = 'Product:Brand:Delete';
        export const insertPermission = 'Product:Brand:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:Brand:Edit';

        export declare const enum Fields {
            BrandId = "BrandId",
            AttributeTypeId = "AttributeTypeId",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
